import { requester } from '../utils';

export const getSettings = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: 'v1/setting',
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('get settings error', err);
        reject(err);
      });
  });
};

export const updateSettings = settingsArray => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/setting`,
        method: 'PUT',
        data: settingsArray
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
